import { apiProxyRequest } from "Api/apiProxyRequest";

import type { BillingUser, BillingUserPermission } from "../types";

export type UpdateBillingUserPayload = {
  permissions: BillingUserPermission[];
};

export const updateBillingUserRequest = (
  billingProfileId: string,
  billingUserId: string,
  payload: UpdateBillingUserPayload
) => {
  return apiProxyRequest<BillingUser>(
    `/billing/profiles/${billingProfileId}/users/${billingUserId}`,
    "PATCH",
    payload
  );
};
